module.exports = __webpack_public_path__ + "static/media/Sándwich de pollo.3bc743c5.jpg";